import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAlertSettings } from "../../store/alert/actions/actionsCreators";
import AlertSettingsForm from "../../components/Alert/AlertSettingsForm";
import PageHeader from "../../shared/PageHeader";
import DashboardLayout from "../../layout/DashboardLayout";

const AlertSettings = () => {
  const dispatch = useDispatch();
  const { alertSettings, loading } = useSelector((state) => state.alert);
  const { user } = useSelector((state) => state.user);
  const token = user?.access_token;

  useEffect(() => {
    if (token) {
      dispatch(getAlertSettings(token));
    }
  }, [dispatch, token]);

  return (
    <>
      <PageHeader 
        title="System Alert Settings" 
        subtitle="Manage system-wide alerts for maintenance, news, and announcements"
      />
      
      <div className="section-main m-3 px-3 py-4 rounded-lg shadow-lg">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading alert settings...</p>
          </div>
        ) : (
          <AlertSettingsForm initialSettings={alertSettings} />
        )}
      </div>
    </>
  );
};

export default DashboardLayout(AlertSettings);